export default "__VITE_ASSET__BB5mF$Zu__$_?component__"